import React, {Component} from 'react';
import Menu from 'react-icons/lib/fa/align-justify';
import Exit from 'react-icons/lib/fa/close';
import { css } from 'aphrodite';
import Reveal from 'react-reveal/Reveal';
import {styles} from '../common/animation';

class Header extends Component {

  constructor(props) {
    super(props)
    this.state = {
      active: false,
    };
  }

  componentWillMount() {
    let newState = Object.assign({}, this.state);
    let len = this.props.titles.length + 1;
    for (let i = 0; i < len; i++){
        newState['hover' + i] = false;
    }
    this.setState(newState);
}

  toggleMenu = (index) => {
    this.setState({active: !this.state.active});
  }


  onClickLink = (el) => {
    this.props.onChangeVieW(el);
  }

  onMouseOver = (index) => {
    let name = 'hover' + index;
    this.setState({[name]: true});
  }

  onMouseOut = (index) => {
    this.setState({['hover' + index]: false});
  }

  renderMenu = () => {
    return this.props.titles.map((el, index) => {
      let hoverIndex = String(index + 1);
      return(
        <div
        key={index}
        onMouseOver={() => this.onMouseOver(hoverIndex)}
        onMouseOut={() => this.onMouseOut(hoverIndex)}
        className={(this.state['hover' + hoverIndex] ? css(styles.bounceTitle) : '')}
        >
          <li className="navigation_element" onClick={this.toggleMenu}><a className="navigation_element-lien" href={`#${el.toLowerCase().replace(/ /g,'')}`} title={el} onClick= {() => this.onClickLink(el)}>{el}</a></li>
        </div>
      )
    });
  }

  render(){
    let burger_color = "#93a4aa";
    let logo = "logo.png";
    return(
         <div className="header">
          <Reveal effect={css(styles.fadeIn)} duration={1500} >
            <div className="headerLeft">
              <div
              onMouseOver={() => this.onMouseOver('0')}
              onMouseOut={() => this.onMouseOut('0')}
              className={(this.state.hover0 ? css(styles.logoPulse) : '')}
              >
                <div className="header_logo-container"
                onClick={() => this.props.onLogoClick()}> 
                  <img className="header_logo" src={logo}  alt={"logo"} />
                </div>
              </div>
            </div>
            <div className="headerRight">
              <button className={'header_burger ' + (this.state.active === true ? 'header_burger-Active' : '')} onClick={this.toggleMenu}>
                { this.state.active ? <Exit size={30} color={burger_color}/> : <Menu size={30} color={burger_color}/>}
              </button>
              <div className="navigation_mobile">
                <ul className={'header_navigation ' + (this.state.active === true ? 'header_navigation-active' : '')}>
                    {this.renderMenu()}
                </ul>
              </div>
            </div>
            </Reveal>
          </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/common/header.js